import * as React from "react";
import { Badge } from "common/components";
function RiskScoreBadge({ riskScore }) {
  const getRiskScoreStyle = () => {
    if (riskScore < 25) return "default";
    if (riskScore < 50) return "info";
    if (riskScore < 75) return "warning";
    return "danger";
  };
  return /* @__PURE__ */ React.createElement(Badge, { size: "sm", variant: getRiskScoreStyle() }, riskScore.toFixed(1));
}
export default RiskScoreBadge;
